import React from "react";
import { Select } from "antd";
import { Text } from "@networkraildigitalfactory/components";
import "./AntdFilters.css";
import { getCurrentFinancialYear } from "../../services/utils";

const OneToOneFilter = (props) => {
  const { Option } = Select;
  const { onYearChange, yearValue } = props;

  const finYears = [];
  const baseYear = 2020;
  const currentYear = new Date().getFullYear();
  // eslint-disable-next-line no-plusplus
  for (let i = baseYear; i <= currentYear; i++) {
    const nextYear = i + 1;
    const currYrTwoDigit = `${i + 1}`.toString().substring(2, 4);
    const currFinYear = `${i}/${currYrTwoDigit}`;
    const nextYrTwoDigit = `${nextYear + 1}`.toString().substring(2, 4);
    const nextFinYear = `${nextYear}/${nextYrTwoDigit}`;
    if (finYears.length <= 12) {
      if (finYears.indexOf(currFinYear) === -1) finYears.push(currFinYear);
      if (finYears.indexOf(nextFinYear) === -1) finYears.push(nextFinYear);
    }
  }

  return (
    <>
      <Text
        wrapper="h4"
        type="body"
        color="#000000"
        style={{ marginLeft: "10px", marginRight: "10px", marginTop: "5px" }}
      >
        Filter by year
      </Text>
      <Select
        placeholder={yearValue}
        style={{ width: 150 }}
        value={yearValue || getCurrentFinancialYear()}
        onChange={onYearChange}
      >
        <Option disabled hidden value="" style={{ color: "#727272" }}>
          {yearValue}
        </Option>
        {finYears.map((year) => {
          return (
            <Option key={year} value={year}>
              {year}
            </Option>
          );
        })}
      </Select>
    </>
  );
};

export default OneToOneFilter;
